const backendUrl = process.env.REACT_APP_BACKEND_URL;
const isSiteInMaintenanceStatus = process.env.REACT_APP_IS_SITE_IN_MAINTENANCE;

export {
  backendUrl,
  isSiteInMaintenanceStatus
};